module.exports = __webpack_public_path__ + "static/red-grunge-67de1b558b6deae36190d83985316343.jpg";